import React from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  Button,
  CircularProgress,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import "../../../styles/FlightRiskAssessment.css";

interface MarkAsResolvedModalProps {
  readonly isOpen: boolean;
  readonly accountName: string;
  readonly isLoading?: boolean;
  readonly onClose: () => void;
  readonly onConfirm: () => void;
}

const MarkAsResolvedModal: React.FC<MarkAsResolvedModalProps> = ({
  isOpen,
  accountName,
  isLoading = false,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={isOpen}
      onClose={isLoading ? undefined : onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        className: "mar-modal-paper",
      }}
    >
      <DialogContent className="mar-modal-content">
        {/* Header row with icon badge and title/subtitle */}
        <div className="mar-modal-header">
          <div className="mar-modal-icon-wrap">
            <CheckIcon className="mar-modal-icon" />
          </div>
          <div className="mar-modal-header-text">
            <Typography className="mar-modal-title">
              Mark as Resolved
            </Typography>
            <Typography className="mar-modal-subtitle">
              This action will update the account status
            </Typography>
          </div>
        </div>

        {/* Divider */}
        <div className="mar-modal-divider" />

        {/* Body content */}
        <div className="mar-modal-body">
          <Typography className="mar-modal-desc">
            You&apos;re about to mark{" "}
            <span className="mar-modal-account-name">
              {accountName}
            </span>{" "}
            as resolved.
          </Typography>

          <Typography className="mar-modal-subdesc">
            Once confirmed, this account will be removed from the active flight
            risk list and will no longer appear in flight risk reports.
          </Typography>
        </div>

        {/* Action Buttons */}
        <div className="mar-modal-actions">
          <Button
            type="button"
            onClick={onClose}
            disabled={isLoading}
            className="mar-modal-btn-cancel"
          >
            Cancel
          </Button>

          <Button
            type="button"
            onClick={onConfirm}
            disabled={isLoading}
            className="mar-modal-btn-confirm"
          >
            {isLoading && <CircularProgress size={16} className="mar-modal-spinner" />}
            Confirm Resolved
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default MarkAsResolvedModal;
